import { render, staticRenderFns } from "./DossierSanitaryVisit.vue?vue&type=template&id=668881ee&scoped=true&"
import script from "./DossierSanitaryVisit.vue?vue&type=script&lang=js&"
export * from "./DossierSanitaryVisit.vue?vue&type=script&lang=js&"
import style0 from "./DossierSanitaryVisit.vue?vue&type=style&index=0&id=668881ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668881ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
